import {
  MDBBtn,
  MDBChip,
  MDBCol,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSelect,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import CallParking from "../../components/topviews/accountsettings/CallParking";
import StorageManager from "../../components/topviews/accountsettings/StorageManager";

import ActiveDirectory from "../../components/topviews/accountsettings/ActiveDirectory";
import GLobalStreamsTeam from "../../components/topviews/accountsettings/GlobalStreamsTeam";
import MultiFactorAuth from "../../components/topviews/accountsettings/MultiFactorAuth";
import VoicemailOperatorSettings from "../../components/topviews/accountsettings/VoicemailOperatorSettings";
// import AccountPinCallerID from "../../components/topviews/accountsettings/AccountPinCallerID";
import { useAdminContext } from "../../components/adminstore/Admin-Context";
import EditWarning from "../../components/header/EditWarning";
import { Tooltip } from "react-tooltip";
import AccPhoneNumbers from "../../components/topviews/accountsettings/AccPhoneNumbers";
import { show_links_tab } from "../../apiclients/apiurls";

function AccountSettingsLanding(props) {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);
  const section5 = useRef(null);
  const section6 = useRef(null);

  const containerRef = useRef(null);

  const [basicActive, setBasicActive] = useState('tab1');
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }
    setBasicActive(value);
  };

  const handleOk = () => {
    setEdited(false);
    setBasicActive(targetView);
    setShowWarning(false);
  };
  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll(".nav-link");
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
      const stickyParent = lastLink.closest(".sticky-top");
      if (stickyParent && lastLink.classList.contains("active")) {
        lastLink.classList.remove("active");
        for (let i = 0; i < scrollspyLinks.length; i++) {
          const firstLink = scrollspyLinks[i];
          const parent = firstLink.closest(".sticky-top");
          if (parent) {
            firstLink.classList.add("active");
            break;
          }
        }
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);


  return (
    <React.Fragment>
      <>
        <MainLinks active={6} />
        <Body
          tablinks={6}
          sublink={128}
          content={
            <>
              <section className="mb-3">
                <div className="card-body card-height">
                  <div className="card-header pb-3">
                    <h5 className="my-0 ">Account Settings</h5>
                  </div>
                  <MDBTabs className="mb-3">
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab1")}
                        active={basicActive === "tab1"}
                      >
                        Settings
                      </MDBTabsLink>
                    </MDBTabsItem>
                    {/* commented below code as part of Jerome Suggested Changes */}
                    {/* <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab2")}
                        active={basicActive === "tab2"}
                      >
                        Voicemail
                      </MDBTabsLink>
                    </MDBTabsItem> */}
                    {/* <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab3")}
                        active={basicActive === "tab3"}
                      >
                        Call Parking
                      </MDBTabsLink>
                    </MDBTabsItem> */}
                    {/* commented below code as part of Jerome Suggested Changes */}
                    {/* {show_links_tab == 1 && (

                      <MDBTabsItem>
                        <MDBTabsLink
                          onClick={() => handleBasicClick("tab4")}
                          active={basicActive === "tab4"}
                        >
                          Active Directory
                        </MDBTabsLink>
                      </MDBTabsItem>
                    )} */}
                    {/*  <MDBTabsItem>
                       <MDBTabsLink
                        onClick={() => handleBasicClick("tab5")}
                        active={basicActive === "tab5"}
                      >
                        Streams Teams
                      </MDBTabsLink>
                    </MDBTabsItem> */}
                    {/* <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab6")}
                        active={basicActive === "tab6"}
                      >
                        Multi Factor Authentication
                      </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab7")}
                        active={basicActive === "tab7"}
                      >
                        Account Pin & Caller ID
                      </MDBTabsLink>
                    </MDBTabsItem> */}
                  </MDBTabs>

                  <MDBTabsContent>
                    <MDBTabsPane open={basicActive === "tab1"}>

                      <MDBRow>
                        <MDBCol
                          size="2"
                          md="2"
                          lg="2"
                          sm="12"
                          className="col-sm-100 pr-0 leftTabs"
                        >
                          <MDBScrollspy container={containerRef}>
                            <MDBScrollspyLink targetRef={section1}>
                              Storage Manager
                            </MDBScrollspyLink>
                          </MDBScrollspy>
                        </MDBCol>

                        <MDBCol
                          size="12"
                          md="10"
                          sm="12"
                          pr-0
                          className="col-sm-100 pr-0 leftTabContent"
                        >
                          <div ref={containerRef} className="scrollspy-example mx-0" style={{ maxHeight: "100vh !important" }}>
                            <section ref={section1} id="section-1">
                              <div class="general-settings">Storage Manager</div>
                              <StorageManager setEdited={setEdited} />
                            </section>
                          </div>
                        </MDBCol>
                      </MDBRow>
                    </MDBTabsPane>
                    {/* commented below code as part of Jerome Suggested Changes */}
                    {/* <MDBTabsPane open={basicActive === "tab2"}> */}
                    {/* <div className="routing-border"></div> */}
                    {/* <section
                        ref={section3}
                        id="section-3"
                        className="p-3 w-70 mob-w-100"
                      >
                        <VoicemailOperatorSettings setEdited={setEdited} />
                      </section>
                    </MDBTabsPane> */}
                    {/* <MDBTabsPane open={basicActive === "tab3"}> 
                      <section
                        ref={section4}
                        id="section-4"
                        className="p-3 w-70 mob-w-100"
                      >
                        <CallParking setEdited={setEdited} />
                      </section>
                    </MDBTabsPane> */}
                    {/* commented below code as part of Jerome Suggested Changes */}
                    {/* {show_links_tab == 1 && (
                      <MDBTabsPane open={basicActive === "tab4"}> */}
                    {/* <div className="routing-border"></div> */}
                    {/* <section
                          ref={section5}
                          id="section-5"
                          className="p-3 w-70 mob-w-100"
                        >
                          <ActiveDirectory setEdited={setEdited} />
                        </section>
                      </MDBTabsPane>
                    )} */}
                    {/* <MDBTabsPane open={basicActive === "tab5"}>
                      
                      <section
                        ref={section6}
                        id="section-6"
                        className="p-3 w-70 mob-w-100"
                      >
                        <GLobalStreamsTeam setEdited={setEdited} />
                      </section>
                    </MDBTabsPane> */}
                    <MDBTabsPane open={basicActive === "tab6"}>
                      <section
                        ref={section1}
                        id="section-1"
                        className="p-3 w-70 mob-w-100"
                      >
                        {/* <MultiFactorAuth setEdited={setEdited} /> */}

                      </section>
                    </MDBTabsPane>
                    {/* <MDBTabsPane open={basicActive === "tab7"}>
                      <section
                        className="p-3 w-80 mob-w-100"
                      >
                        <AccPhoneNumbers />

                      </section>

                    </MDBTabsPane> */}
                  </MDBTabsContent>
                </div>
              </section>

              <MDBModal
                open={AddNumbers}
                setOpen={setAddNumbers}
                tabIndex="-1"
              >
                <MDBModalDialog>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>{t("add_Numbers")}</MDBModalTitle>
                      <MDBBtn
                        className="btn-close"
                        color="none"
                        onClick={toggleShow12}
                      ></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className="position-relative">
                        <div className="form-outline">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                        </div>
                        <MDBIcon
                          fas
                          icon="search"
                          className="custom-search_icon"
                        />
                      </div>

                      <div className="chips chips-placeholder mt-3">
                        <MDBChip
                          className="m-chip d-inline py-2 px-3"
                          closeIcon
                        >
                          5548565854
                        </MDBChip>
                        <MDBChip
                          className="m-chip d-inline py-2 px-3"
                          closeIcon
                          size="sm"
                        >
                          9854582548
                        </MDBChip>
                        <MDBChip
                          className="m-chip d-inline py-2 px-3"
                          closeIcon
                        >
                          5548565854
                        </MDBChip>
                      </div>
                      <div className="text-primary my-2">
                        <a href="">Select All</a>
                      </div>

                      <div className="position-relative mb-3">
                        <div className="form-outline">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                        </div>
                        <MDBIcon
                          fas
                          icon="search"
                          className="custom-search_icon"
                        />
                      </div>

                      <MDBTable>
                        <MDBTableHead>
                          <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Extension</th>
                            <th scope="col">Locatoion</th>
                          </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                          <tr>
                            <td>Nick Layender</td>
                            <td>2581</td>
                            <td>San Francisco</td>
                          </tr>
                          <tr>
                            <td>Nick Layender</td>
                            <td>2581</td>
                            <td>San Francisco</td>
                          </tr>
                          <tr>
                            <td>Nick Layender</td>
                            <td>2581</td>
                            <td>San Francisco</td>
                          </tr>
                          <tr>
                            <td>Nick Layender</td>
                            <td>2581</td>
                            <td>San Francisco</td>
                          </tr>
                          <tr>
                            <td>Nick Layender</td>
                            <td>2581</td>
                            <td>San Francisco</td>
                          </tr>
                        </MDBTableBody>
                      </MDBTable>
                    </MDBModalBody>
                    <MDBModalFooter>
                      <MDBBtn color="secondary" onClick={toggleShow12}>
                        {t("close")}
                      </MDBBtn>
                      <MDBBtn>{t("add")}</MDBBtn>
                    </MDBModalFooter>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
              {showWarning && (
                <EditWarning
                  warningToggle={warningToggle}
                  setShowWarning={setShowWarning}
                  onOk={handleOk}
                />
              )}
            </>
          }
        />
        {/* <Footer /> */}

        <Tooltip anchorSelect=".infoToolTip" place="right" className="exampleTooltip">
          Selecting Groups allows users to set assigned DIDs <br /> of users in the selected group as Caller ID.
        </Tooltip>

        <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
          Remove
        </Tooltip>
      </>
    </React.Fragment>
  );

}

export default AccountSettingsLanding